export default __webpack_public_path__ + "static/media/chevron-down-no-space.8884cdfe.svg";